/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.10.1
 */
import { A as Action, d as defineCustomElement$1 } from './action.js';

const CalciteAction = Action;
const defineCustomElement = defineCustomElement$1;

export { CalciteAction, defineCustomElement };

//# sourceMappingURL=calcite-action.js.map